import { TSpecItem } from '@/shared/types/product-types'

import { SpecItem } from '../spec-item/spec-item'

import styles from './spec-group.module.scss'

export type SpecGroupProps = {
	items: Record<string, TSpecItem>
	title: string
	isCollapsed?: boolean
}

export const SpecGroup = ({ title, items, isCollapsed = false }: SpecGroupProps): JSX.Element => {
	const groupClassName = `${styles.specGroup} ${isCollapsed ? styles.collapsed : ''}`.trim()

	return (
		<section className={groupClassName}>
			<p className={styles.title}>{title}</p>
			<dl className={styles.list}>
				{Object.values(items)?.map(({ values, name }) => (
					<SpecItem name={name} values={values} key={name} />
				))}
			</dl>
		</section>
	)
}
